module.exports = {
  "country": "DE",
  "artist": "Max Mutzke",
  "song": "Can´t Wait Until Tonight",
  "year": "2004",
  "place": "8",
  "spotify": "4u7z06Xi0TdYbp6k6pOIRP"
};